const FormPageData = [
  {
    id: 1000,
    form: `create-deal-sheet`,
    page: `1`,
    imageURL: "../../images/Manitoba/forms/deal-sheet/create-deal-sheet-1.png",
    description: `<p>The deal sheet acts as your confirmation of the transaction 
    details, including commission. Staff use it to generate your Trade Record 
    Sheets for signing. Follow the steps below to easily generate 
    your deal sheet from the details in SkySlope.</p>`,
    hotspots: [],
  },
  {
    id: 1001,
    form: `MLS-listing-contract`,
    page: `1`,
    imageURL: "../../images/Manitoba/forms/listing/MLS-listing-1.png",
    description: `<p>The MLS Real Estate Listing Contract stands as 
    the primary document employed in acquiring residential resale properties. As you 
    complete this agreement, it is imperative to verify all property 
    details with secondary sources. While the listing 
    Agent bears the responsibility of ensuring listing accuracy, it remains crucial 
    to undertake thorough due diligence for your Client, refraining from solely 
    depending on the listing information.     </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `8%`,
        data: `<p>
        <strong>Seller side (left):</strong> Enter the full legal name(s) of the 
        property owner(s) on the "BETWEEN" line, followed by the Seller's address, 
        city, province, and postal code. Take the extra step of cross-referencing 
        your Clients' IDs to guarantee accuracy. If the Client is a corporation, be 
        sure to obtain documents, such as the Articles of Incorporation, to 
        confirm signing authority. Obtain the Land Title document to verify all the 
        names that should be on the agreement.<br><br>
        <strong>Listing Brokerage side (right):</strong> Enter the Brokerage name 
        (e.g., eXp Realty), followed by the Brokerage's address, city, province, 
        and postal code.</p>`,
      },
      {
        x: `1.5%`,
        y: `22%`,
        data: `<p><strong>Listing Authority and Term:</strong><br><br>
        <strong>A.</strong> Enter the expiry date of the listing (day, month, year). 
        The listing automatically expires at 11:59 p.m. on this date unless renewed 
        in writing.<br><br>
        <strong>Effective Date:</strong> Enter the date the contract comes into 
        full force and effect (day, month, year). This is typically the signing 
        date.</p>`,
      },
      {
        x: `1.5%`,
        y: `26%`,
        data: `<p><strong>Section 1B:</strong><br><br>
        By signing this contract, the Seller gives the Brokerage permission to:
        <ol class="letter-list"><li>
        Collect any information about the property from anyone — including government offices, utility companies, or other organizations</li>
        <li>Advertise the property anywhere they see fit, including online. Once the listing goes on MLS®, the information becomes public — and the Seller is agreeing upfront that this is acceptable, even if potential Buyers and their Agents see it</li>
        <li>Use, share, and keep the Seller's personal information and property details for the purpose of marketing and selling the home</li>
        <li>Show the home to potential Buyers at reasonable times — the Seller agrees not to block or limit this</li>
        <li>Put up "For Sale" and "Sold" signs on the property, and allow other real estate Agents (not just the listing Agent) to bring Buyers through for showings</li>
        </ol>
</p>`,
      },
      {
        x: `1.5%`,
        y: `43%`,
        data: `<p><strong>Property:</strong> Enter the civic address of the 
        property being listed, including street address, city/town/municipality, 
        province, and postal code. Verify the address details in the Land Title 
        document. Keep in mind that the title does not always match the  
        civic address. For example, in the case where the property is used  
        as an income property.<br><br>
        <strong>Brief Legal Description:</strong> Insert the legal description of 
        the property (found on the Title or tax assessment). If unavailable at 
        signing, note "TBD" and update before listing goes live.</p>`,
      },
      {
        x: `50%`,
        y: `43%`,
        data: `<p><strong>Terms of Sale:</strong><br><br>
        <strong>Listing Price:</strong> Enter the agreed-upon listing price for 
        the property.<br><br>
        <strong>Possession Date:</strong> Enter the desired possession date. If 
        flexible or not yet determined, enter "TBD" or "Negotiable".</p>`,
      },
      {
        x: `1.5%`,
        y: `49%`,
        data: `<p><strong>Section 4 (Listing Details and Cooperating Agents):</strong> 
        The Seller is giving the Brokerage permission to do the following.
        <ol class="letter-ol"><li>
        Put the property on the MLS® system and any other real estate boards in Manitoba that the Brokerage has access to. Every Agent who is a member of those boards is automatically allowed to act as a Co-operating Agent, meaning they can bring Buyers to the property.
        <li>
        Share the listing details publicly, including everything in this contract, the Data Input Form with property details like size and features, the Property Disclosure Statement outlining any known issues with the property, and the final sale price once a firm unconditional offer has been accepted. This information also gets shared with other real estate professionals who subscribe to the MLS® system.
        </li>
        <li>
        Load all listing and sale information into the MLS® database. The Seller acknowledges that once the data is in there, the real estate associations own it and can do what they want with it. This includes sharing it with brokers, government departments, appraisers, and municipalities; marketing the property in any format including online; using the data for statistics and historical records; and using it in any other way they consider appropriate.
        </li>
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `76%`,
        data: `<p><strong>Listing Brokerage's Remuneration (Total Commission):</strong><br><br>
        <strong>5A.</strong> Fill in <strong>ONLY ONE</strong> field — either a 
        flat dollar amount ($) <strong>OR</strong> a commission percentage (%) 
        of the total selling price. GST is added to the amount indicated in this section.<br><br>
        This commission becomes payable in the scenarios listed in 5A(i), (ii), 
        and (iii), including holdover provisions (sales within 60 days after 
        expiry to a Buyer who inspected during the listing term).</p>`,
      },
      {
        x: `1.5%`,
        y: `90%`,
        data: `<p>
        <strong>5B:</strong> The Seller may still owe the Brokerage money even if the sale doesn't 
        go through. If a Buyer makes a valid, unconditional offer and the Seller turns it down 
        without a good reason, the full commission is still owed. If a Buyer signs a contract but 
        then defaults and walks away, the Seller owes the Brokerage either 50% of the Buyer's 
        deposit or the full commission, whichever amount is lower.</p>`,
      },
    ],
  },
  {
    id: 1002,
    form: `MLS-listing-contract`,
    page: `2`,
    imageURL: "../../images/Manitoba/forms/listing/MLS-listing-2.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `8%`,
        data: `<p><strong>Co-operating Agent Compensation (5C):</strong> Fill in 
        <strong>ONLY ONE</strong> field — either a flat dollar amount ($) 
        <strong>OR</strong> a percentage (%) of the sale price that will be 
        offered to the Buyer's (co-operating) Agent.
        GST is added to the amount indicated in this section.<br><br>
        This is the portion of the Listing Brokerage's commission that will be 
        shared with the cooperating Brokerage representing the Buyer.</p>`,
      },
      {
        x: `1.5%`,
        y: `13%`,
        data: `<p><strong>Exclusions (5D):</strong> List any Buyers or parties 
        that are excluded from this listing contract (e.g., a specific Buyer the 
        Seller is already negotiating with privately). If there are no exclusions, 
        enter <strong>"NONE"</strong>. Do not leave this field blank.
        <br><br>
        <strong>5E:</strong> The Seller pre-authorizes the Brokerage to take its 
        commission directly from the sale proceeds or deposit money, so the 
        Brokerage does not have to chase the Seller for payment after closing.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `18%`,
        data: `<p><strong>The Listing Brokerage Agrees As Follows (Section 6):</strong> 
        The Listing Brokerage agrees to act as the Seller's Agent (except 
        in limited joint representation situations), to share property information 
        with co-operating Agents, and to not accept remuneration from the Buyer 
        without the Seller's knowledge and consent.</p>`,
      },
      {
        x: `1.5%`,
        y: `25.5%`,
        data: `<p><strong>Section 7 (The Seller Acknowledges and Agrees As Follows):</strong>
        This section outlines the Seller's responsibilities and important things they are agreeing 
        to.
        <ol class="letter-ol">
        <li>
        The Seller must pass along any inquiries or offers to purchase the property to the 
        Listing Brokerage right away, without delay.
        </li>
        <li>
        The commission becomes due and payable when the Buyer takes legal possession of the property.  
        If the commission goes unpaid, the Listing Brokerage is entitled to charge interest starting 
        30 days after possession, at a rate of 2% per month which works out to 24% per year.
        </li>
        <li>
        The Listing Brokerage is allowed to work with other Buyers and Sellers at the same time as 
        representing the Seller. If the Listing Brokerage ends up representing both the Seller and a 
        potential Buyer for the same property, both parties will be asked to sign a Limited Joint 
        Representation Agreement that clearly outlines the limits of what the Listing Brokerage can 
        do for each side.
        </li>
        <li>
        Unless the Seller is told otherwise, any Co-operating Agent involved in the deal is working 
        for the Buyer, not the Seller. The Seller should keep this in mind during negotiations.
        </li>
        <li>
        The Seller is pledging the property itself as security for any money owed to the Listing 
        Brokerage under this contract. If necessary, the Listing Brokerage has the right to register 
        a caveat, which is a formal legal notice, on the property title to protect its claim.
        </li>
        <li>
        The Manitoba Real Estate Association and its member boards are simply collectors and 
        distributors of property information and are not responsible if any of it turns out to be 
        inaccurate. The Seller agrees not to hold them legally liable for any errors in the 
        listing information.
        </li> 
        <li>
        If the Seller's spouse has ever lived in the property but is not listed as an owner on the 
        title, the Seller must inform the Listing Brokerage. This is important because under 
        Manitoba law the spouse may have homestead rights, which could affect the sale.
        </li>
        <li>
        If anything significant changes about the physical condition or status of the property while 
        it is listed, the Seller must notify the Listing Brokerage promptly. This applies for the 
        entire listing term including any extensions.
        </li>
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `53%`,
        data: `<p><strong>Miscellaneous Provisions (Section 8):</strong> Defines 
        key terms used in the contract (e.g., "period", "Property", "Sale"), 
        confirms Manitoba law governs, and specifies that any amendments must 
        be made in writing and signed by both parties.</p>`,
      },
      {
        x: `1.5%`,
        y: `71%`,
        data: `<p><strong>Entire Agreement (Section 9):</strong> Confirms that 
        the Listing Contract includes this Agreement, the Data Input Form, and 
        the Property Disclosure Statement (when attached and signed). The Seller 
        acknowledges receipt and understanding of the contract by signing below. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `80%`,
        data: `<p><strong>Signatures:</strong> All signatures must be completed 
        to make the contract valid.<br><br>
        <strong>Seller's Signature(s):</strong> All Sellers listed on Title must 
        sign (Seller 1 and Seller 2 if applicable).<br><br>
        <strong>Witness Signature:</strong> A witness must sign to confirm the 
        Seller's signature(s).<br><br>
        <strong>Agent Signature:</strong> The Listing Brokerage's representative 
        (Agent) must sign.<br><br>
        <strong>Date:</strong> Enter the day, month, and year the contract is 
        being signed.</p>`,
      },
    ],
  },
  {
    id: 1004,
    form: `form-e`,
    page: `1`,
    imageURL: "../../images/Manitoba/forms/listing/forme-1.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `12%`,
        data: `<p><strong>Listing Agreement Date:</strong> Enter the date that the 
        Listing Agreement (to which this Form E is attached) was signed. This 
        ensures the Service Agreement is properly linked to the corresponding 
        Listing Agreement.</p>`,
      },
      {
        x: `1.5%`,
        y: `17%`,
        data: `<p><strong>Identity of the Parties:</strong> Complete both sides of 
        this section.<br><br>
        <strong>Brokerage side:</strong> Enter the Brokerage name, 
        Brokerage address, the representative (Agent) name, and Agent contact details.<br><br>
        <strong>Person Receiving Services side:</strong> Enter the full legal name(s) 
        of the Seller(s), the property address, and Seller contact details. If there 
        are multiple Sellers, ensure all names are listed.</p>`,
      },
      {
        x: `1.5%`,
        y: `33%`,
        data: `<p><strong>Description of the Services to Be Provided:</strong> Check 
        the boxes that apply to the services you will be providing to the Seller. 
        For a typical Seller representation, box <strong>h)</strong> "All Services 
        contained in the Listing Agreement to which this agreement forms a part" 
        is usually checked, as it captures all services outlined in the Listing 
        Agreement.<br><br>
        Use box <strong>i) Other</strong> to add or expand upon any additional 
        services not covered by the Listing Agreement. Leave blank if not applicable.</p>`,
      },
      {
        x: `1.5%`,
        y: `84%`,
        data: `<p><strong>Date this Agreement is Made and the Date it Expires:</strong><br><br>
        <strong>a)</strong> Enter the date the Service Agreement is being signed 
        (typically the same date as the Listing Agreement).<br><br>
        <strong>b)</strong> Enter the expiry time and date of the agreement. This 
        should match the expiry date of the Listing Agreement to which this form 
        is attached (e.g., 11:59 PM on the last day of the listing term).</p>`,
      },
    ],
  },
  {
    id: 1005,
    form: `form-e`,
    page: `2`,
    imageURL: "../../images/Manitoba/forms/listing/forme-2.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `10%`,
        data: `<p><strong>Rights to Terminate Before Expiry:</strong> Unless terms 
        are written in the space provided, neither party has the right to terminate 
        this agreement before the expiry date. If early termination rights are 
        being granted, clearly outline the conditions in this section (e.g., 
        written notice requirements, holdover provisions, etc.). Leave blank if 
        no early termination rights apply.</p>`,
      },
      {
        x: `1.5%`,
        y: `18%`,
        data: `<p><strong>Terms of Payment / Compensation:</strong> Only check 
        <strong>ONE</strong> box. If both are checked, 5a) will be deemed to 
        apply by default.<br><br>
        <strong>a)</strong> Check this box if compensation is a percentage of the 
        purchase price. Enter the agreed-upon percentage. GST is added to the amount indicated in this section.<br><br>
        <strong>b)</strong> Check this box if compensation is a fixed dollar 
        amount. Enter the agreed-upon flat fee. GST is added to the amount indicated in this section.<br><br>
        The compensation must match the terms outlined in the Listing Agreement.</p>`,
      },
      {
        x: `1.5%`,
        y: `33%`,
        data: `<p><strong>Other Terms:</strong><br><br>
        <strong>a)</strong> Check this box if you want the terms in this Service 
        Agreement to take precedence over any conflicting terms in the Listing 
        Agreement.<br><br>
        <strong>b)</strong> Check this box and use the space to insert any 
        additional custom terms that apply to this agreement. If the term is 
        not from the MREA Booklet or an eXp approved term, have the Client's 
        lawyer draw up the custom term to best protect your Client(s).</p>`,
      },
      {
        x: `1.5%`,
        y: `75%`,
        data: `<p><strong>Signatures of the Parties:</strong> All parties must 
        sign to make the agreement valid.<br><br>
        <strong>Brokerage side:</strong> Print the representative's (Agent's) name 
        and have them sign.<br><br>
        <strong>Seller side:</strong> Have all Sellers listed in Section 1 sign 
        the agreement. If there are multiple Sellers, all of their signatures are required.</p>`,
      },
    ],
  },
  {
    id: 1005,
    form: `direction-offers`,
    page: `1`,
    imageURL: "../../images/Manitoba/forms/listing/direction-offers-1.png",
    hotspots: [
      {
        x: `5%`,
        y: `15%`,
        data: `<p><strong>Property and Parties:</strong> This section identifies 
        which listing the direction applies to.<br><br>
        <strong>Property address:</strong> Enter the full civic address (street, 
        city, province, postal code) of the property being listed.<br><br>
        <strong>Between Seller(s):</strong> Enter the full legal name(s) of the 
        Seller(s) as they appear on Title. If there are multiple Sellers, list 
        all of them.<br><br>
        <strong>Listing Brokerage:</strong> Enter the Listing Brokerage name.
        </p>`,
      },
      {
        x: `5%`,
        y: `29%`,
        data: `<p><strong>Agreement Expiry Dates and MLS® Number:</strong><br><br>
        <strong>Listing Agreement expiry date:</strong> Enter the expiry date 
        from the MLS® Listing Contract (day, month, year). This must match 
        exactly.<br><br>
        <strong>Service Agreement expiry date:</strong> Enter the expiry date 
        from the Form E Service Agreement (typically the same as the Listing 
        Agreement expiry).<br><br>
        <strong>MLS® Number:</strong> Enter the MLS® listing number assigned 
        when the property is entered into the system. If the listing hasn't been 
        activated yet, this can be added later — but it should be on file before 
        the listing goes live.</p>`,
      },
      {
        x: `5%`,
        y: `37%`,
        data: `<p><strong>Direction Options — Check All That Apply:</strong> 
        This is where the Seller specifies what restrictions apply and until 
        when. Check the boxes that apply and enter the date(s) the restriction 
        ends.<br><br>
        <strong>No showings to prospective Buyers until ___:</strong> Use when 
        the Seller is not ready for Buyer showings (e.g., still preparing the 
        home, tenant issues, staging incomplete).<br><br>
        <strong>No inspections by Salespersons/Brokerages until ___:</strong> 
        Use when other Agents should not preview the property (e.g., before 
        official launch).<br><br>
        <strong>No presentation of offers until ___:</strong> Use when the Seller 
        wants to collect Offers and review them all on a specific date (commonly 
        used in hot markets to encourage multiple offers / bidding war strategy).<br><br>
        <strong>Tip:</strong> Discuss the strategy with the Seller. Holding Offers 
        can drive competition but may also discourage some Buyers — make sure 
        the Seller understands the trade-offs.</p>`,
      },
      {
        x: `5%`,
        y: `45%`,
        data: `<p><strong>Important Note on Date Sequencing:</strong> The date 
        chosen for "presentation of offers" CANNOT be earlier than the dates set 
        for showings or inspections. For example, if showings begin April 20, 
        offer presentation must be April 20 or later — Buyers need an opportunity 
        to view the property before submitting offers.</p>`,
      },
      {
        x: `5%`,
        y: `49%`,
        data: `<p><strong>Acknowledgement Clauses (1–3):</strong> These clauses 
        explain the Seller's commitments. Review them with the Seller before 
        signing — particularly:<br><br>
        <strong>Clause 2:</strong> The direction is <strong>irrevocable</strong>. 
        Once signed, the Brokerage is obligated to follow it. The Seller cannot 
        easily change their mind partway through.<br><br>
        <strong>Clause 3:</strong> The Brokerage is <strong>not required</strong> 
        to inform the Seller of offers received before the presentation date — 
        even if those offers exceed the list price or are time-sensitive. Make 
        sure the Seller fully understands this before signing.</p>`,
      },
      {
        x: `5%`,
        y: `66%`,
        data: `<p><strong>Important Reminder:</strong> This form does NOT cancel 
        the Listing Agreement or Service Agreement — both remain in full force 
        and effect. This direction only restricts showings, inspections, and 
        offer presentations until the specified dates.</p>`,
      },
      {
        x: `5%`,
        y: `78%`,
        data: `<p><strong>Dated at ___ this ___ day of ___, 20___:</strong><br><br>
        <strong>Location:</strong> Enter the city or town where the document is 
        being signed (e.g., Winnipeg, Brandon, Swan River).<br><br>
        <strong>Date:</strong> Enter the day, month, and year the direction is 
        being signed (typically the same date as the Listing Agreement).</p>`,
      },
      {
        x: `5%`,
        y: `83%`,
        data: `<p><strong>Signatures:</strong> All signatures must be completed 
        to make the direction valid.<br><br>
        <strong>Seller Signature:</strong> All Sellers listed on Title must 
        sign. If there are multiple Sellers, all of their signatures are required.
        <br><br>
        <strong>Witness Signature:</strong> A witness must sign to confirm the 
        Seller's signature.<br><br>
        <strong>Listing Brokerage Name:</strong> Print the Listing Brokerage name.
        <br><br>
        <strong>Listing Brokerage Representative:</strong> The Agent's signature 
        on behalf of the Listing Brokerage.</p>`,
      },
    ],
  },
  {
    id: 1006,
    form: `limited-joint-representation`,
    page: `1`,
    imageURL: "../../images/Manitoba/forms/ack-limited-joint-rep-1.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `13%`,
        data: `<p><strong>Identity of the Parties:</strong> Complete both sides 
        of this table.<br><br>
        <strong>Brokerage side (left):</strong> Enter the Brokerage name, Brokerage address, 
        and the Agent's name.<br><br>
        <strong>Person Receiving Services side (right):</strong> Enter the full 
        legal name(s) of the Client(s) signing this acknowledgement, and their 
        address. If multiple Clients are signing (e.g., spouses), list all names.<br><br>
        <strong>Note:</strong> This form is signed separately by each party 
        involved in the limited joint representation — one copy is signed by 
        the Seller, and a separate copy is signed by the Buyer.</p>`,
      },
      {
        x: `1.5%`,
        y: `27%`,
        data: `<p><strong>Address of Property:</strong> Check the ONE box that 
        applies to the person signing this form, and enter the property address 
        where applicable.<br><br>
        <strong>Box 1 — "If I am a Seller":</strong> Check this if the signer 
        is the Seller. Enter the property address being sold.<br><br>
        <strong>Box 2 — "If I am a Buyer":</strong> Check this if the signer 
        is a Buyer and a specific property has been identified. Enter the address 
        of the property they are interested in.<br><br>
        <strong>Box 3 — "If I am a Buyer, the address is unknown":</strong> 
        Check this if the signer is a Buyer who hasn't yet identified a specific 
        property — this provides advance consent in case a dual representation 
        scenario arises later.</p>`,
      },
      {
        x: `1.5%`,
        y: `42%`,
        data: `<p><strong>Date of the Acknowledgement:</strong> Enter the date 
        the Client is signing this acknowledgement (day, month, year). This is 
        typically signed at the same time as the Listing Agreement (for Sellers) 
        or Buyer Service Agreement (for Buyers) to obtain advance consent.</p>`,
      },
      {
        x: `1.5%`,
        y: `47%`,
        data: `<p><strong>Acknowledgement and Agreement (Section 3):</strong> 
        This is the core consent clause. The Client is acknowledging that a 
        conflict of interest may arise when the Brokerage represents both sides 
        of a transaction (or two Buyers for the same property), and they consent 
        to limited joint representation under specific terms.<br><br>
        <strong>Key things the Client must understand before signing:</strong><br>
        <ol>  
        <li>The Agent <strong>cannot disclose</strong> the other party's motivation, 
        price, terms, or competing offers.</li>
        <li>The Agent must deal with both parties <strong>fairly and impartially</strong>.</li>
        <li>Information that would normally be shared in single representation 
        will be limited.</li>
        </ol>
        Take time to walk the Client 
        through these terms so they fully understand what they're agreeing to.</p>`,
      },
    ],
  },
  {
    id: 1007,
    form: `limited-joint-representation`,
    page: `2`,
    imageURL: "../../images/Manitoba/forms/ack-limited-joint-rep-2.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `10%`,
        data: `<p><strong>Other Terms (Section 4):</strong><br/><br/>
        <ol class="letter-ol">  
        <li>Standard interpretation clause — singular includes 
        plural.</li>
        <li>If this acknowledgement conflicts with any other 
        agreement between the Brokerage and the Client, this acknowledgement 
        takes precedence.</li>
        <li>Additional Terms: Use this space to add any 
        custom terms specific to this limited joint representation arrangement. 
        If the term is not from the MREA Booklet or an approved term, have 
        the Client's lawyer draw up the custom term to best protect the Client. 
        Leave blank if no additional terms apply.</li>
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `62%`,
        data: `<p><strong>Acknowledgement of Review and Receipt (Section 5):</strong> 
        Check <strong>BOTH</strong> boxes to confirm:<br/><br/>
        <ul>  
        <li><strong>Box 1:</strong> The Client has received and reviewed the 
        "Working with a REALTOR®" brochure published by MREA, which explains 
        limited joint representation in plain language.</li>
        <li><strong>Box 2:</strong> The Client has received a copy of this signed 
        acknowledgement and agreement.</li>
        </ul>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `72%`,
        data: `<p><strong>Signatures of the Parties:</strong> Both parties must 
        sign to make the acknowledgement valid.<br/><br/>
        <ol class="letter-ol">  
        <li><strong>Brokerage side (left):</strong> Print the Agent's name and 
        have them sign.</li>
        <li><strong>Person Receiving Services side (right):</strong> All Clients 
        listed in Section 1 must sign. If multiple Clients are listed (e.g., spouses 
        co-purchasing or co-selling), all signatures are required.</li>
        <strong>Reminder:</strong> A separate copy of this form must also be 
        signed by the other party in the transaction (e.g., if this copy is 
        signed by the Seller, the Buyer must sign their own copy as well).
        </ol>
        </p>`,
      },
    ],
  },
  {
    id: 1008,
    form: `mb-wwar`,
    page: `1`,
    imageURL: "../../images/Manitoba/forms/wwar/mb-wwar-1.png",
    hotspots: [],
  },
  {
    id: 1009,
    form: `mb-wwar`,
    page: `2`,
    imageURL: "../../images/Manitoba/forms/wwar/mb-wwar-2.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `8%`,
        data: `<p><strong>The 5 Core Duties of a REALTOR®:</strong> This page 
        outlines the fundamental obligations a REALTOR® owes to their Client in 
        an agency relationship. Walk through these with your Client so they 
        understand what they can expect from you:<br/><br/>
        <ol>  
        <li><strong>Loyalty</strong> — Serve the Client's best interests above 
        all else, including your own.</li>
        <li><strong>Obedience</strong> — Follow all lawful instructions from 
        the Client.</li>
        <li><strong>Discretion</strong> — Keep the Client's confidential 
        information private.</li>
        <li><strong>Competence</strong> — Apply reasonable care and skill to 
        the services provided.</li>
        <li><strong>Accounting</strong> — Properly handle all money, deposits, 
        and property entrusted to you.</li>
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `41%`,
        data: `<p><strong>Agency Disclosure:</strong> This section explains that 
        REALTORS® are bound by a strict Code of Ethics and must disclose — 
        <strong>in writing</strong> — which party they represent (Buyer or 
        Seller) at the <strong>earliest possible opportunity</strong>.<br><br>
        <strong>Practical tip:</strong> Always present this brochure and obtain 
        a signed Acknowledgement (page 7) before providing any services that 
        go beyond casual incidental contact. This protects both you and the 
        Client.</p>`,
      },
    ],
  },
  {
    id: 1010,
    form: `mb-wwar`,
    page: `3`,
    imageURL: "../../images/Manitoba/forms/wwar/mb-wwar-3.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `5%`,
        data: `<p><strong>Introduction:</strong> Sets up key terminology used 
        throughout the brochure — "REALTOR®" refers to the individual 
        representative, and "Brokerage" refers to the firm. 
        Reminds the Client that buying or selling a home is one of the largest 
        financial transactions of their life and the legal relationship matters.</p>`,
      },
      {
        x: `1.5%`,
        y: `22%`,
        data: `<p><strong>Your Relationship with the REALTOR®:</strong> Explains 
        how an Agent/Client relationship is formed.<br><br>
        <strong>Key points to discuss with the Client:</strong><br>
        <ol>  
        <li>A relationship is typically formed by signing a Listing Contract, 
        Service Agreement, or Buyer Service Agreement.</li>
        <li>For <strong>Buyers</strong>, an agency relationship can also be 
        formed through <strong>implied conduct</strong> — such as viewing 
        properties, gathering information, or negotiating — even without a 
        signed agreement.</li>
        <li>Under <em>The Real Estate Services Act</em>, a written service 
        agreement is <strong>required</strong> before a REALTOR® can provide 
        real estate services.</li>
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `86%`,
        data: `<p><strong>Duties and Obligations of the REALTOR®:</strong> Once 
        an Agent/Client relationship is formed, the REALTOR® and Brokerage must 
        act in the Client's best interests — this leads into the 5 core duties 
        outlined on the previous page (Loyalty, Obedience, Discretion, 
        Competence, Accounting).</p>`,
      },
    ],
  },
  {
    id: 1011,
    form: `mb-wwar`,
    page: `4`,
    imageURL: "../../images/Manitoba/forms/wwar/mb-wwar-4.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `8%`,
        data: `<p><strong>Types of Agency Relationships — Overview:</strong> 
        This section introduces the three possible agency scenarios in real 
        estate: <strong>Single Representation</strong>, <strong>Joint 
        Representation</strong>, and <strong>No Representation</strong>. The 
        next several pages explain each one.</p>`,
      },
      {
        x: `1.5%`,
        y: `19%`,
        data: `<p><strong>Single Representation (Most Common Scenario):</strong> 
        Two different Brokerages — one represents the Buyer, one represents 
        the Seller. Each REALTOR® works exclusively for their own Client and 
        owes them all five core agency duties.<br><br>
        <strong>Key takeaway for Clients:</strong> Unless otherwise agreed, 
        this is the default arrangement. As a REALTOR®, you are your Client's advocate, and 
        the other party has their own REALTOR® advocating for them.
        </p>`,
      },
    ],
  },
  {
    id: 1012,
    form: `mb-wwar`,
    page: `5`,
    imageURL: "../../images/Manitoba/forms/wwar/mb-wwar-5.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `5%`,
        data: `<p><strong>Joint Representation (Limited Joint Representation):</strong> 
        Occurs when the <strong>same Brokerage</strong> represents both the 
        Buyer and Seller in the same transaction — even if two different 
        REALTORS® are involved, as long as they work for the same Brokerage 
        (e.g., both at the same Brokerage), a conflict of interest exists.<br><br>
        <strong>Critical points to explain to your Client:</strong><br>
        <ol>  
        <li>Both parties must <strong>consent in writing</strong> to limited 
        joint representation.</li>
        <li>As a REALTOR®, you must treat both parties <strong>fairly and 
        impartially</strong> — they cannot advocate for one over the other.</li>
        <li>Certain information that would normally be kept confidential may 
        need to be disclosed to both parties.</li>
        <li>The Client will be asked to sign an <strong>Acknowledgement of 
        Limited Joint Representation</strong>.</li>
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `78%`,
        data: `<p><strong>Important Advance Consent Note:</strong> The terms 
        of any Listing, Buying, or Service Agreement may include <strong>advance 
        consent</strong> to limited joint representation. If the Client does 
        NOT want to agree to this in advance, they have the right to request 
        the agreement be amended to remove that consent. Discuss this with 
        Clients clearly before signing.</p>`,
      },
    ],
  },
  {
    id: 1013,
    form: `mb-wwar`,
    page: `6`,
    imageURL: "../../images/Manitoba/forms/wwar/mb-wwar-6.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `5%`,
        data: `<p><strong>No Agency Representation (Customer vs. Client):</strong> 
        Occurs when a person interacts with a REALTOR® without forming an 
        Agent/Client relationship. <br/><br/>Common examples:<br/><br/>
        <ol>  
        <li>A Buyer attends an <strong>open house</strong> and writes an offer 
        through the Seller's REALTOR® (without their own Agent).</li>
        <li>A REALTOR® contacts a <strong>private Seller (FSBO)</strong> to 
        bring their Buyer Client to purchase the home.</li>
        </ol>
        In these cases, as a REALTOR®, you must clearly disclose that you 
        represent the <strong>other party only</strong>.</p>`,
      },
      {
        x: `1.5%`,
        y: `57%`,
        data: `<p><strong>Duties Owed to a "Customer" (Unrepresented Party):</strong> 
        Even without an agency relationship, the REALTOR® still owes the 
        unrepresented party:<br/><br/>
        <ol>  
        <li><strong>Honesty and Fairness</strong> — When answering questions 
        about the property.</li>
        <li><strong>Care and Skill</strong> — When helping complete paperwork, 
        present offers, and explain legalities.</li>
        </ol>
        <strong>Important limitation:</strong> A "Customer" cannot expect the 
        REALTOR® to negotiate on their behalf or otherwise advocate for their 
        interests — that would conflict with the REALTOR's duty to their 
        actual Client.</p>`,
      },
    ],
  },
  {
    id: 1014,
    form: `mb-wwar`,
    page: `7`,
    imageURL: "../../images/Manitoba/forms/wwar/mb-wwar-7.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `5%`,
        data: `<p><strong>Acknowledgement Section — Purpose:</strong> This is 
        the only fillable page in the brochure. It documents that the Client 
        has received and reviewed the brochure, and confirms the agency 
        relationship being established between the Client and the REALTOR®/
        Brokerage. This page should be completed at the earliest possible 
        opportunity.</p>`,
      },
      {
        x: `1.5%`,
        y: `13%`,
        data: `<p><strong>Name of REALTOR®:</strong> Print the full name of 
        the Agent who is providing services to the Client.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `22%`,
        data: `<p><strong>Name of Brokerage:</strong> Print the name of the 
        Brokerage the Agent works for. This is the legal 
        entity that holds the agency relationship — not just the individual 
        Agent.</p>`,
      },
      {
        x: `1.5%`,
        y: `31%`,
        data: `<p><strong>Representation Disclosure — Check the ONE Box That 
        Applies:</strong><br/><br/>
        <strong>"The Seller's interest and not my own"</strong> — Check this 
        when you are representing the Seller and the Buyer has no representation of 
        their own.<br><br>
        <strong>"The Buyer's interest and not my own"</strong> — Check this 
        when you are representing a Buyer and the Seller has no representation of their own.
        <br/><br/> 
        <strong>"My interest as a Seller"</strong> — Check this when you are 
        representing the Seller and acting in their best interest throughout 
        the transaction.<br><br>
        <strong>"My interest as a Buyer"</strong> — Check this when you are 
        representing the Buyer and acting in their best interest throughout 
        the transaction.<br><br>
        <strong>"Circumstances may arise..." (Joint Representation Consent)</strong> — Check this when your client is agreeing in advance to limited joint 
        representation in the event that you end up representing both the Buyer and Seller in the same transaction.<br><br>
        <strong>"Other"</strong> — Use only for unusual situations not covered by any of the options above; describe the circumstances clearly in the space provided.</p>`,
      },
      {
        x: `1.5%`,
        y: `63%`,
        data: `<p><strong>Signature and Date:</strong><br><br>
        <strong>Signature:</strong> The Client (customer or Client) signs here 
        to acknowledge receipt of the brochure and the disclosure made.<br><br>
        <strong>Date:</strong> Enter the date the Client is signing (day, 
        month, year). This should match or precede the date services begin.<br><br>
        <strong>Best practice:</strong> Provide a signed copy to the Client 
        and retain a copy in your file. This is your proof of compliance with 
        the Code of Ethics disclosure requirements.</p>`,
      },
    ],
  },
  {
    id: 1015,
    form: `mb-wwar`,
    page: `8`,
    imageURL: "../../images/Manitoba/forms/wwar/mb-wwar-8.png",
    hotspots: [],
  },
  {
    id: 1016,
    form: `sch1-res-pds`,
    page: `1`,
    imageURL: "../../images/Manitoba/forms/sch1-pds/sch1-res-pds-1.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `15%`,
        data: `<p>
        <strong>Date of Statement:</strong> Enter the date the Seller is 
        completing this disclosure (day, month, year).<br><br>
        <strong>Address of Property:</strong> Enter the full civic address of 
        the property being sold.<br><br>
        <strong>Name(s) of Seller(s):</strong> Enter the full legal name(s) of 
        ALL Sellers on Title. If there are multiple Sellers, list each one.<br><br>
        <strong>Name(s) of Buyer(s):</strong> Enter the full legal name(s) of 
        the Buyer(s) who will receive this statement. May be left blank initially 
        and filled in when an offer is accepted.</p>`,
      },
      {
        x: `1.5%`,
        y: `30%`,
        data: `<p><strong>Important Notes — Read Carefully with Your Seller:</strong><br><br>
        <ol>  
        <li>The Seller is <strong>not obligated</strong> to complete this form 
        unless they have agreed to do so as part of the purchase contract.<br><br>
        <li>If this disclosure forms part of the contract, it <strong>must be 
        referenced in sections 6 and 7</strong> of PART ONE of the Residential 
        Offer to Purchase Contract.<br><br>
        <li>The Seller must answer based on their <strong>current actual 
        knowledge</strong> — true and accurate representations only.<br><br>
        <li>Any "NOT CORRECT" or "DO NOT KNOW" answer <strong>requires a full 
        explanation</strong> in the Explanations section. Partial or incomplete 
        explanations can result in liability for the Seller.<br><br>
        <strong>Best practice:</strong> Encourage your Seller to be thorough 
        and honest. Disclosure protects them from future legal action.</p>`,
      },
      {
        x: `1.5%`,
        y: `49%`,
        data: `<p><strong>1. Ownership / Occupancy:</strong> Complete all three 
        parts:<br><br>
        <ol class="letter-ol">  
        <li>Enter the number of years the Seller has 
        <strong>owned</strong> the property.<br><br>
        <li> Enter the number of years the Seller has 
        <strong>occupied</strong> the property (may be different from ownership 
        — e.g., if the property has been rented out).<br><br>
        <li>If the Seller is NOT the most recent occupant 
        (e.g., property was tenanted), they must disclose the most recent 
        occupant's name and duration of occupancy in the Explanations section 
        on page 3.</li>
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `62%`,
        data: `<p><strong>Land / Structures (Items 2–8) — How to Answer:</strong> 
        For each statement, the Seller places a check mark (or their initials) 
        in ONE of three columns:<br><br>
        <strong>CORRECT</strong> — The statement is true to the Seller's 
        knowledge.<br><br>
        <strong>NOT CORRECT</strong> — The statement is false. A full 
        explanation MUST be provided on page 3.<br><br>
        <strong>DO NOT KNOW</strong> — The Seller doesn't have information 
        either way. An explanation should still be provided on page 3.<br><br>
        <strong>Items 2–8 cover:</strong> regulatory compliance, building 
        permits, local improvement notices, illegal grow-ops/drug production, 
        insurance history, structural movement, and hidden defects.</p>`,
      },
    ],
  },
  {
    id: 1017,
    form: `sch1-res-pds`,
    page: `2`,
    imageURL: "../../images/Manitoba/forms/sch1-pds/sch1-res-pds-2.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `7%`,
        data: `<p><strong>Land / Structures Continued (Items 9–14):</strong> 
        These items address common property issues. The Seller must check 
        CORRECT, NOT CORRECT, or DO NOT KNOW for each.<br><br>
        <strong>9.</strong> Water issues — flooding, seepage, sewer backup 
        (very important in Manitoba).<br>
        <strong>10.</strong> Roof or shingle damage and leaks.<br>
        <strong>11.</strong> Hidden damage from weather, pests, or moisture.<br>
        <strong>12.</strong> Pest/rodent/insect issues within the past 12 
        months.<br>
        <strong>13.</strong> Defects with doors, windows, cabinetry, or 
        built-ins.<br>
        <strong>14.</strong> Failed window seals (fogging or moisture between 
        panes).<br><br>
        <strong>Tip:</strong> Walk through these with the Seller carefully — 
        items like past sewer backups or basement flooding are often forgotten 
        but are material disclosures.</p>`,
      },
      {
        x: `1.5%`,
        y: `33%`,
        data: `<p><strong>Systems / Inclusions (Items 15–22):</strong> Covers 
        the property's mechanical and environmental systems.<br><br>
        <strong>15–16.</strong> On-site wastewater systems (septic tank/field/
        holding tank) — only applies if NOT connected to municipal sewer.<br>
        <strong>17.</strong> Potable water supply — contamination, mechanical, 
        treatment issues.<br>
        <strong>18.</strong> Electrical/mechanical/plumbing fixtures in proper 
        working order (only for items included in the sale).<br>
        <strong>19.</strong> Hazardous materials — asbestos, radon (above 
        federal guidelines), lead plumbing, aluminum or knob & tube wiring.<br>
        <strong>20.</strong> Radon gas testing — if YES (Correct), provide 
        test date, results, and any mitigation system details on page 3.<br>
        <strong>21.</strong> Mold requiring remediation (beyond general 
        cleaning).<br>
        <strong>22.</strong> Fireplace/woodstove condition and compliance.<br><br>
        <strong>Important warning (Item 22):</strong> Buyers should be aware 
        that wood-burning equipment that's insurable for the Seller may 
        require costly upgrades for the Buyer's insurer.</p>`,
      },
    ],
  },
  {
    id: 1018,
    form: `sch1-res-pds`,
    page: `3`,
    imageURL: "../../images/Manitoba/forms/sch1-pds/sch1-res-pds-3.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `7%`,
        data: `<p><strong>General (Items 23–24) — Catch-All Statements:</strong> 
        These are broad, sweeping statements designed to capture anything not 
        covered above.<br><br>
        <strong>23.</strong> Any defect/deficiency that is structural, a health 
        or safety concern, or that renders the property unusable for its 
        intended purpose.<br><br>
        <strong>24.</strong> Any defect/deficiency that is <strong>not readily 
        visible</strong> upon reasonable inspection (i.e., hidden issues the 
        Seller knows about but a Buyer wouldn't easily notice).<br><br>
        <strong>Critical advice for the Seller:</strong> If they know of 
        ANYTHING that fits these categories and hasn't been disclosed elsewhere, 
        they must mark NOT CORRECT and explain. Failing to disclose known 
        latent defects can lead to lawsuits even after closing.</p>`,
      },
      {
        x: `1.5%`,
        y: `22%`,
        data: `<p><strong>Explanations Section:</strong> This is where the 
        Seller provides full and complete explanations for EVERY item answered 
        "NOT CORRECT" or "DO NOT KNOW".<br><br>
        <strong>Best practices for writing explanations:</strong><br>
        <ol>  
        <li>Reference the item number (e.g., "Item 9 — basement seepage").<br>
        <li>Be specific: dates, locations, scope of issue, any repairs done.<br>
        <li>Include any professional reports, invoices, or documentation if 
        relevant.<br>
        <li>If space runs out, attach a separate Schedule and reference it 
        here.</li>
        </ol>
        <strong>Remember:</strong> An incomplete or vague explanation can 
        be just as damaging as no disclosure at all — it can be deemed 
        misleading and create liability.</p>`,
      },
    ],
  },
  {
    id: 1019,
    form: `sch1-res-pds`,
    page: `4`,
    imageURL: "../../images/Manitoba/forms/sch1-pds/sch1-res-pds-4.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `9%`,
        data: `<p><strong>Seller's Acknowledgement and Agreement:</strong> <br/><br/>By 
        signing, the Seller confirms:<br/>
        <ol class="letter-ol">  
        <li>Information is true and complete based on current 
        actual knowledge.</li>
        <li>Reasonable efforts were made to confirm 
        accuracy.</li>
        <li>The Buyer will rely on these representations.</li>
        <li>If the Seller learns of any changes between 
        signing and closing, they <strong>must promptly notify the Buyer in 
        writing</strong> — this is an ongoing obligation, not a one-time 
        disclosure.</li>
        </ol>
        <strong>Make sure your Seller understands clause (d)</strong> — if 
        anything changes between now and closing (e.g., new water damage, 
        broken furnace), they have a legal duty to update the Buyer.</p>`,
      },
      {
        x: `1.5%`,
        y: `33%`,
        data: `<p><strong>Seller Signature(s):</strong> ALL Sellers listed on 
        Title must sign here. There are two signature lines provided — if 
        there are more than two Sellers, attach an additional signature page.<br><br>
        <strong>Tip:</strong> Make sure the Seller dates their signatures — 
        the Date of Statement at the top of page 1 should align with when 
        the Seller signs.</p>`,
      },
      {
        x: `1.5%`,
        y: `44%`,
        data: `<p><strong>Buyer's Acknowledgement:</strong> By signing, the 
        Buyer confirms:<br><br>
        <ol class="letter-ol">  
        <li>They received this disclosure either before 
        signing the Offer to Purchase OR they received and approved it after 
        signing.</li>
        <li>The statements are <strong>representations, NOT 
        warranties</strong> — this is an important legal distinction.</li>
        <li>There may still be defects the Seller is unaware 
        of.</li>
        <li>The disclosure is a <strong>starting point</strong> 
        for the Buyer's own inquiries, not a substitute for due diligence.</li>
        <li>The Buyer is responsible for inspecting the 
        property — and is encouraged to hire a qualified inspector.</li>
        </ol>
        <strong>Advice for Buyer's Agents:</strong> Always recommend a 
        professional home inspection. Do not let your Buyer treat the PDS as 
        a substitute for inspection.</p>`,
      },
      {
        x: `1.5%`,
        y: `64%`,
        data: `<p><strong>Buyer Date and Signature(s):</strong><br><br>
        <strong>Date:</strong> Enter the date the Buyer is signing this 
        acknowledgement (day, month, year).<br><br>
        <strong>Buyer Signature(s):</strong> ALL Buyers listed on the Offer 
        to Purchase must sign here. Two signature lines are provided — attach 
        an additional page if more Buyers need to sign.</p>`,
      },
    ],
  },
  {
    id: 1020,
    form: `sch1-condo-pds`,
    page: `1`,
    imageURL: "../../images/Manitoba/forms/sch1-pds/sch1-condo-pds-1.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `15%`,
        data: `<p>
        <strong>Date of Statement:</strong> Enter the date the Seller is 
        completing this disclosure (day, month, year).<br><br>
        <strong>Address of Condominium Unit:</strong> Enter the full civic 
        address of the unit, including unit number (e.g., Unit 305 - 123 Main 
        Street, Winnipeg, MB).<br><br>
        <strong>Names of Sellers:</strong> Enter the full legal names of 
        ALL Sellers on Title.<br><br>
        <strong>Names of Buyers:</strong> Enter the full legal names of 
        the Buyers who will receive this statement.<br><br>
        <strong>Note:</strong> This form is specifically for <strong>condominium 
        units</strong> — do not use it for freehold residential properties 
        (use the Residential PDS instead).</p>`,
      },
      {
        x: `1.5%`,
        y: `30%`,
        data: `<p><strong>Important Notes — Read Carefully with Your Seller:</strong><br><br>
        <ol>  
        <li>The Seller is <strong>not obligated</strong> to complete this form 
        unless they agreed to as part of the purchase contract.</li>
        <li>If this disclosure forms part of the contract, it <strong>must be 
        referenced in sections 6 and 7</strong> of PART ONE of the Condominium 
        Unit Offer to Purchase Contract.</li>
        <li>The Seller must answer based on their <strong>current actual 
        knowledge</strong>.</li>
        <li>Any "NOT CORRECT" or "DO NOT KNOW" answer <strong>requires a full 
        explanation</strong> on page 3. Vague or incomplete explanations can 
        result in Seller liability.</li>
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `49%`,
        data: `<p><strong>1. Ownership / Occupancy:</strong><br><br>
        <ol class="letter-ol">  
        <li>Number of years the Seller has <strong>owned</strong> 
        the unit.</li>
        <li>Number of years the Seller has <strong>occupied</strong> 
        the unit (may differ from ownership if the unit was rented out).</li>
        <li>If the Seller is not the most recent occupant, 
        they must list the most recent occupant's name and duration of 
        occupancy in the Explanations section.</li>
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `59%`,
        data: `<p><strong>2. Exclusive Use Common Elements (Condo-Specific):</strong> 
        This is unique to condo PDS forms. "Exclusive use common elements" are 
        areas of the common property that the unit owner has exclusive use of 
        AND is required to maintain (e.g., balconies, patios, parking stalls, 
        storage lockers).<br><br>
        <strong>If CORRECT:</strong> The remaining statements in this PDS apply 
        to BOTH the unit AND the exclusive use common elements the Seller 
        maintains. This is important because issues with these areas (like 
        balcony damage) must be disclosed.<br><br>
        <strong>If NOT CORRECT:</strong> No explanation required — simply 
        means the Seller has no exclusive use common elements to maintain.<br><br>
        <strong>Best practice:</strong> Review the condo declaration to 
        confirm exactly what the Seller is responsible for maintaining.</p>`,
      },
      {
        x: `1.5%`,
        y: `73%`,
        data: `<p><strong>Unit / Structures (Items 3–6):</strong> The Seller 
        checks ONE column per statement: CORRECT, NOT CORRECT, or DO NOT KNOW.<br><br>
        <strong>3.</strong> Compliance with municipal/regulatory requirements 
        (zoning, fire code, health, occupancy).<br>
        <strong>4.</strong> Compliance with title restrictions.<br>
        <strong>5.</strong> All renovations/alterations during ownership were 
        done in compliance with the <strong>condominium declaration and 
        bylaws</strong> AND with required permits.<br>
        <strong>6.</strong> No notice of local improvements affecting the 
        unit.<br><br>
        <strong>Condo tip:</strong> Many owners forget that condo renovations 
        often require approval from the Condominium Corporation. If approval 
        wasn't obtained for past work, item 5 should be answered NOT CORRECT 
        with an explanation.</p>`,
      },
    ],
  },
  {
    id: 1021,
    form: `sch1-condo-pds`,
    page: `2`,
    imageURL: "../../images/Manitoba/forms/sch1-pds/sch1-condo-pds-2.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `7%`,
        data: `<p><strong>Unit / Structures Continued (Items 7–15):</strong> 
        Standard property issue disclosures adapted for condo units.<br><br>
        <strong>7.</strong> No illegal grow-op or drug production.<br>
        <strong>8.</strong> No cancelled or refused fire insurance on the 
        unit.<br>
        <strong>9.</strong> No hidden cracking, shifting, or structural 
        movement.<br>
        <strong>10.</strong> No water flooding, seepage, or infiltration.<br>
        <strong>11.</strong> No roof/shingle damage or leaks — note this 
        <strong>only applies if the roof forms part of the Unit</strong> 
        (typically not applicable for apartment-style condos, but may apply 
        to townhome-style condos).<br>
        <strong>12.</strong> No hidden damage from weather, pests, or moisture.<br>
        <strong>13.</strong> No rodent/insect issues within the past 12 
        months.<br>
        <strong>14.</strong> No defects with doors, windows, cabinetry.<br>
        <strong>15.</strong> No failed window seals — <strong>only applies 
        if the windows form part of the Unit</strong> (windows are often 
        common element in condos).<br><br>
        <strong>Condo tip:</strong> Review the condo declaration to determine 
        what is part of the Unit versus what is common element — this 
        affects which items apply.</p>`,
      },
      {
        x: `1.5%`,
        y: `42%`,
        data: `<p><strong>Systems / Inclusions (Items 16–23):</strong><br><br>
        <strong>16–17.</strong> On-site wastewater (septic) — rarely applies 
        to condos but listed for completeness.<br>
        <strong>18.</strong> Potable water supply issues — only applies if 
        fixtures are part of the Unit.<br>
        <strong>19.</strong> Electrical/mechanical/plumbing fixtures in working 
        order — only for items included in the sale (e.g., appliances).<br>
        <strong>20.</strong> Hazardous materials — asbestos, radon (above 
        federal guidelines), lead plumbing, aluminum or knob & tube wiring.<br>
        <strong>21.</strong> Radon gas testing — if CORRECT, provide test 
        date, results, and mitigation system details on page 3.<br>
        <strong>22.</strong> Mold requiring remediation.<br>
        <strong>23.</strong> Fireplace/woodstove condition (if applicable to 
        the Unit).<br><br>
        <strong>Warning (Item 23):</strong> Existing wood-burning equipment 
        insurable for the Seller may require costly upgrades for the Buyer's 
        insurer. Important consideration in condos where fireplace upgrades 
        may also require Condo Corporation approval.</p>`,
      },
    ],
  },
  {
    id: 1022,
    form: `sch1-condo-pds`,
    page: `3`,
    imageURL: "../../images/Manitoba/forms/sch1-pds/sch1-condo-pds-3.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `7%`,
        data: `<p><strong>General (Items 24–26) — Catch-All and Condo-Specific:</strong><br><br>
        <strong>24.</strong> Any undisclosed defect that is structural, a 
        health/safety concern, or makes the unit unusable.<br><br>
        <strong>25.</strong> Any undisclosed defect that is <strong>not readily 
        visible</strong> upon reasonable inspection (hidden latent defects 
        the Seller is aware of).<br><br>
        <strong>26. Special Assessments (Condo-Specific — Very Important):</strong> 
        The Seller confirms they have NOT been informed by the Condominium 
        Corporation of any approved special assessment that will be payable 
        later.<br><br>
        <strong>Why this matters:</strong> Special assessments can be 
        thousands of dollars (sometimes tens of thousands) for major repairs 
        like elevator replacements, roof work, or building envelope repairs. 
        If a special assessment has been approved, the Buyer needs to know 
        before purchasing — otherwise they could inherit a major financial 
        obligation immediately after closing.<br><br>
        <strong>Best practice:</strong> Always request a current Status 
        Certificate from the Condominium Corporation in addition to this 
        disclosure.</p>`,
      },
      {
        x: `1.5%`,
        y: `27%`,
        data: `<p><strong>Explanations Section:</strong> Required for EVERY 
        item marked "NOT CORRECT" or "DO NOT KNOW" (except item 2 which 
        doesn't require an explanation if NOT CORRECT).<br><br>
        <strong>How to write good explanations:</strong><br>
        <ol>  
        <li>Reference the item number (e.g., "Item 10 — water seepage in 
        spare bedroom").<br>
        <li>Be specific: dates, location, extent, repairs done, professionals 
        consulted.</li>
        <li>Include supporting documents where helpful (engineer's reports, 
        repair invoices, condo correspondence).</li>
        <li>For condo issues, reference any communications from the Condo 
        Corporation or property manager.</li>
        <li>If space is insufficient, attach an additional Schedule and 
        reference it here.</li>
        </ol>
        <strong>Remember:</strong> Vague answers create liability. Full and 
        honest disclosure protects the Seller from post-closing claims.</p>`,
      },
    ],
  },
  {
    id: 1023,
    form: `sch1-condo-pds`,
    page: `4`,
    imageURL: "../../images/Manitoba/forms/sch1-pds/sch1-condo-pds-4.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `9%`,
        data: `<p><strong>Seller's Acknowledgement and Agreement:</strong> <br/><br/>By 
        signing, the Seller confirms:
        <ol class="letter-ol">  
        <li>All information is true and complete based on 
        current actual knowledge.</li>
        <li>Reasonable efforts were made to verify the 
        statements.</li>
        <li>The Buyer will rely on these representations 
        when making their decision.</li>
        <li> <strong>Ongoing duty</strong> — if anything 
        changes between signing and closing (e.g., new water leak, special 
        assessment approved by Condo Corp), the Seller MUST promptly inform 
        the Buyer in writing.</li>
        </ol>
        <strong>Critical for condo Sellers:</strong> Special assessments and 
        notices from the Condo Corporation can arrive at any time. Make 
        sure your Seller understands they need to forward any such 
        communications received between signing and closing.</p>`,
      },
      {
        x: `1.5%`,
        y: `31%`,
        data: `<p><strong>Seller Signature(s):</strong> ALL Sellers listed on 
        Title must sign here. Two signature lines are provided — attach an 
        additional signature page if there are more than two Sellers.<br><br>
        <strong>Tip:</strong> Make sure the signature date aligns with the 
        Date of Statement at the top of page 1.</p>`,
      },
      {
        x: `1.5%`,
        y: `42%`,
        data: `<p><strong>Buyer's Acknowledgement:</strong> By signing, the 
        Buyer confirms:<br><br>
        <ol class="letter-ol">  
        <li>They received this disclosure either before 
        signing the Offer to Purchase OR they received and approved it after 
        signing.</li>
        <li>The statements are <strong>representations, NOT 
        warranties</strong> — a critical legal distinction.</li>
        <li>There may be defects the Seller is unaware of.</li>
        <li>The disclosure is a <strong>starting point</strong> 
        for the Buyer's own inquiries, not a substitute for due diligence.</li>
        <li>The Buyer is responsible for inspecting the 
        unit — a professional inspection is strongly recommended.</li>
        </ol><br/>
        <strong>Critical advice for Buyer's Agents on condos:</strong> <br/>Beyond 
        the unit inspection, always review:<br>
        • The Status Certificate / Estoppel Certificate<br>
        • Condo Declaration, Bylaws, and Rules<br>
        • Reserve Fund Study<br>
        • Recent AGM minutes and financial statements<br>
        • Insurance certificate</p>`,
      },
      {
        x: `1.5%`,
        y: `62%`,
        data: `<p><strong>Buyer Date and Signature(s):</strong><br><br>
        <strong>Date:</strong> Enter the date the Buyer is signing this 
        acknowledgement (day, month, year).<br><br>
        <strong>Buyer Signature(s):</strong> ALL Buyers listed on the Offer 
        to Purchase must sign. Two signature lines are provided — attach 
        additional pages if more Buyers need to sign.</p>`,
      },
    ],
  },
  {
    id: 1024,
    form: `mls-marketing-release`,
    page: `1`,
    imageURL: "../../images/Manitoba/forms/listing/mls-marketing-release-1.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `22%`,
        data: `<p><strong>Identification of Parties and Property:</strong> Complete 
        all fields in this section:<br><br>
        <strong>Agent(s):</strong> Enter the Agent's name (if multiple, list all). 
        <br><br>
        <strong>Seller(s):</strong> Enter the full legal name(s) of the 
        Seller(s) listed on Title.<br><br>
        <strong>Listing Brokerage:</strong> Enter the name of the Listing 
        Brokerage.<br><br>
        <strong>Property:</strong> Enter the civic address of the property the 
        listing schedule applies to.</p>`,
      },
      {
        x: `1.5%`,
        y: `40%`,
        data: `<p><strong>Acknowledgement Clauses (1-6):</strong> These clauses 
        explain that the MLS® system requires fair and equal access for all 
        REALTORS®, and that this schedule allows a listing to be entered into the 
        MLS® system on the signing date while delaying active marketing until a 
        specified release date (for example, when staging or repairs need to be 
        completed). Review these terms with the Seller to ensure they understand.</p>`,
      },
      {
        x: `1.5%`,
        y: `64%`,
        data: `<p><strong>Marketing Release Date (6a):</strong> Enter the date 
        when active marketing of the property will officially begin. Before this 
        date, NO active marketing may occur, including: sign installation, showings, 
        open houses, internet advertising, REN advertising, REALTOR.ca posting, 
        or auto-prospecting.<br><br>
        <strong>Important:</strong> Any active marketing before this date could 
        result in a Professional Standards issue for the Listing Agent.</p>`,
      },
      {
        x: `1.5%`,
        y: `76.5%`,
        data: `<p><strong>Date Fields:</strong><br><br>
        <strong>"Dated the ___ day of ___, 20___":</strong> Enter the date the 
        schedule is being completed (typically the same date as the Listing 
        Agreement).<br><br>
        <strong>"Signed by the Seller(s) this ___ day of ___, 20___":</strong> 
        Enter the date the Seller(s) are signing the schedule.</p>`,
      },
      {
        x: `1.5%`,
        y: `85%`,
        data: `<p><strong>Signatures:</strong> All signatures must be completed 
        to make the schedule valid.<br><br>
        <strong>Witness Signatures (left column):</strong> A witness must sign 
        for each Seller's signature.<br><br>
        <strong>Seller Signature(s) (right column):</strong> All Sellers listed 
        on Title must sign (Seller 1 and Seller 2 if applicable).<br><br>
        <strong>Listing Brokerage's Representative:</strong> The Agent must sign 
        and enter the date of signing.</p>`,
      },
    ],
  },
];

export default FormPageData;

/*

{
    id: 1002,
    form: ``,
    page: `1`,
    imageURL: "../../images/Manitoba/forms/listing/MLS-listing-2.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `9%`,
        data: `<p>...</p>`,
      },
    ],
  },



*/
